export const NAME = 'ARTICLES';

export const articleInfo = (store) => store[NAME].info.data;
